"use strict";

exports.__esModule = true;
exports.ZONE_POSITION_MAP = exports.AD_TYPE = exports.AD_INTERACTION = void 0;
// TODO - a workaround that need to be fixed from Product side (or move it to Strapi Config)
var ZONE_POSITION_MAP = exports.ZONE_POSITION_MAP = {
  715922: 2,
  // Staging
  718566: 7,
  // Staging
  708387: 2,
  // Live
  711467: 7 // Live
};
var AD_INTERACTION = exports.AD_INTERACTION = {
  ELIGIBLE: 'ELIGIBLE',
  VIEWABLE: 'VIEWABLE',
  REDIRECT: 'REDIRECT'
};

// AD TYPE give different type of ads
var AD_TYPE = exports.AD_TYPE = {
  BANNER: 'banner',
  LISTING: 'listing',
  CAROUSEL: 'carousel'
};